import { useHistory } from 'react-router-dom';
import { dispatch } from '../store/state';

export const AppLogout = (e) => {
  if (e) {
    e.preventDefault();
  }
  dispatch({
    type: 'SET_USER',
    payload: {},
  });
  dispatch({
    type: 'SET_COMPANY',
    payload: {},
  });
  dispatch({
    type: 'CREATE_CAMP_DATA',
    payload: {},
  });
};
